import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare var require: any;

if (environment.production) {
  enableProdMode();
}



(window as any).__app_translations = {
  0: require('../src/assets/i18n/pt.json'),
  1: require('../src/assets/i18n/en.json')
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
